import axios from "axios";

export default async function fetchAutoRouteSetting() {
    const url = `${process.env.NEXT_PUBLIC_AUTO_ROUTE_SETTING_CDN}?q=${new Date().getTime()}`;
    let result = null;
    const res = await axios({
        method: "get",
        url: url,
    });
    if (res?.status === 200) {
        result = res?.data;
    }
    return result;
}
